import { put, takeLatest } from "redux-saga/effects";
import { getMyPeerQuestionnaire } from "src/redux/actions";
import { IGetMyPeerQuestionnaireAction } from "../../types";
import { SagaIterator } from "@redux-saga/core";
import { IQuestionnaire } from "src/common/types";

type FetchMyQuestionnaire = SagaIterator | Promise<IQuestionnaire>;
export function* fetchMyQuestionnaire({
  payload: { lng, questionnaireId }
}: IGetMyPeerQuestionnaireAction): FetchMyQuestionnaire {
  try {
    const questionnaire = yield getMyPeerQuestionnaire(questionnaireId, lng);
    yield put({
      payload: questionnaire,
      type: "GET_MY_PEER_QUESTIONNAIRE_FULFILLED"
    });
  } catch (e) {
    // tslint:disable-next-line:no-console
    console.error(e);
    yield put({ type: "GET_MY_PEER_QUESTIONNAIRE_REJECTED" });
  }
}

export default function* myPeerQuestionnaireWatcher() {
  yield takeLatest("GET_MY_PEER_QUESTIONNAIRE", fetchMyQuestionnaire);
  yield takeLatest("REFETCH_MY_PEER_QUESTIONNAIRE", fetchMyQuestionnaire);
}
